/**
 * /journey/launch — Sandbox session bootstrap.
 *
 * The CustomerJourney owner page opens this URL in a new tab with
 *   #token=...&next=/dashboard
 * We read the hash (never the search string, so the token stays out of
 * URL bar / referer headers), write it to the same localStorage key the
 * AuthContext reads on mount, then replace() into `next` so the React
 * Router picks up the now-authenticated session.
 */
import { useEffect } from "react";

const TOKEN_KEY = "maxsc_session_token";

export default function JourneyLaunch() {
    useEffect(() => {
        const hash = (window.location.hash || "").replace(/^#/, "");
        const params = new URLSearchParams(hash);
        const token = params.get("token");
        const next = params.get("next") || "/dashboard";
        if (!token) {
            window.location.replace("/");
            return;
        }
        try { window.localStorage.setItem(TOKEN_KEY, token); } catch { /* noop */ }
        // Use replace so the launcher URL doesn't pollute back-button history.
        window.location.replace(next);
    }, []);

    return (
        <div className="min-h-screen bg-zinc-950 text-white flex items-center justify-center">
            <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-400">
                Launching sandbox preview…
            </div>
        </div>
    );
}
